// here keep all app constans
export const APP_STAGE = {
  LOCAL: "local",
  DEVEL: "devel",
  STAGE: "stage",
  PREPROD: "preprod",
  PROD: "prod",
};

export const DETAILS_DRAWER_WIDTH = 360;

export const LANGUAGE_KEY_IN_LOCAL_STORAGE = "language";
export const FILTER_SEPARATOR = "^";
export const FORMAT_NUMBER_SEPARATOR = " ";
export const APP_STAGE_BAR_HEIGHT = "22px";
export const DEFAULT_TEXT_FIELD_MAX_LENGTH = "256";
export const DEFAULT_MULTILINE_TEXT_FIELD_MAX_LENGTH = "1024";

export const TEXT_FIELD_TYPE = "text";
export const NUMERIC_FIELD_TYPE = "numeric";
export const INTEGER_FIELD_TYPE = "integer";
export const CHECKBOX_FIELD_TYPE = "checkbox";
export const SELECT_FIELD_TYPE = "select";
export const AUTOCOMPLETE_FIELD_TYPE = "autocomplete";
export const BOOLEAN_FIELD_TYPE = "boolean";
export const DATE_FIELD_TYPE = "date";
export const DATETIME_TO_DATE_FIELD_TYPE = "datetime_to_date";
export const DATE_TO_DATETIME_FIELD_TYPE = "date_to_datetime";
export const DATE_RANGE_FIELD_TYPE = "date_range";
export const DATETIME_TO_DATE_RANGE_FIELD_TYPE = "datetime_to_date_range";
export const DATETIME_TO_DATE_RANGE_START_FIELD_SUBTYPE =
  "datetime_to_date_range_start";
export const DATETIME_TO_DATE_RANGE_END_FIELD_SUBTYPE =
  "datetime_to_date_range_end";
export const NUMERIC_RANGE_FIELD_TYPE = "numeric_range";
export const INTEGER_RANGE_FIELD_TYPE = "integer_range";
export const BUTTON_FIELD_TYPE = "button_type";
export const DATE_TIME_FIELD_TYPE = "datetime";
export const DATE_TIME_RANGE_FIELD_TYPE = "datetime_range";
export const TIME_FIELD_TYPE = "time";
export const TIME_RANGE_FIELD_TYPE = "time_range";

export const TABLE_TEXT_FIELD_MAX_LENGTH = "64";

export const ORDERING_DIRECTION_ASC = "asc";
export const ORDERING_DIRECTION_DESC = "desc";

export const SELECTED_ROW_COLOR = "var(--selected-row)";
export const FAVORITE_ROW_COLOR = "var(--favorite)";
export const CLOSED_ROW_COLOR = "var(--closed)";
export const ALERT_ROW_COLOR = "var(--red-light)";
export const SUCCES_ROW_COLOR = "var(--green-light)";
export const GREEN_ROW_COLOR = "var(--green)";

export const PAGINATION_PAGE_SIZE = 10;
export const BIG_PAGINATION_PAGE_SIZE = 100;

export const AAD_MAIL_DOMAIN = "oliviacentre.com";

export const DOCS_RESTRICTED_USER = "docs_restricted_user";
export const DOCS_RESTRICTED_ROLE = "docs_restricted_role";

export const MAX_FILENAME_LENGTH_CHARS = 200;
export const MAX_ALLOWED_ENCLOSURE_SIZE_IN_BYTES = 52428800;
export const MAX_ALLOWED_FILE_SIZE_IN_MB =
  MAX_ALLOWED_ENCLOSURE_SIZE_IN_BYTES / 1048576;

export const ERROR_TEXT_STYLE = {
  marginLeft: 0,
  marginRight: 0,
  fontWeight: "bold",
  color: "red",
  minWidth: "180px",
};

export const UNIQUE_ERROR_TEXT = {
  helperText: "field should be unique",
  helperTextStyle: ERROR_TEXT_STYLE,
};

export const DIALOG_EDIT_MODE = "edit_mode";
export const DIALOG_CREATE_MODE = "create_mode";
export const DIALOG_PREVIEW_MODE = "preview_mode";
export const DIALOG_COPY_MODE = "copy_mode";

export const BOMSTANDARD_KIND_BASIC = "basic";
export const BOMSTANDARD_KIND_AUXILIARY = "auxiliary";
export const BOMSTANDARD_KIND_SERVICE = "service";
export const BOMSTANDARD_KIND_MASS = "mass";
export const BOMSTANDARD_RELATED_KINDS = [BOMSTANDARD_KIND_AUXILIARY];

export const ITEM_KIND_MATERIAL = "material";
export const ITEM_KIND_SERVICE = "service";
export const ITEM_KIND_TOOL = "tool";
export const ITEM_KIND_EQUIPMENT = "equipment";
export const ITEM_KIND_ALL = "all_items";

export const TRANSACTION_KIND_IN = "trans_in";
export const TRANSACTION_KIND_OUT = "trans_out";
export const TRANSACTION_KIND_MOVE = "trans_move";
export const TRANSACTION_KIND_DELETE = "trans_delete";
export const RESERVATION_KIND = "reservation";

export const AAD_LOGIN_SYSTEM = "aad";
